module.exports = __webpack_public_path__ + "static/media/white_filter_icon.a19a17ab.svg";